import component from "containers/StaticPages/pages/PrivacyPolicy";

export default {
  key: "privacy-policy",
  title: "Privacy Policy",
  path: "/:user?/privacy-policy",
  pageName: "privacyPolicy",
  linkTarget: "/privacy-policy",
  component,
};
